import React from 'react';
import { RuleSet } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { FallbackView } from '../../FallbackView';

interface NoConnectionViewProps {
  styles?: RuleSet<object>;
}

export const NoConnectionView: React.FC<NoConnectionViewProps> = ({
  styles
}) => {
  const { t } = useTranslation();

  return (
    <FallbackView
      width={150}
      height={150}
      title={t('common.no_connection_title')}
      text={t('common.no_connection_text')}
      styles={styles}
    />
  );
};
